/**
 * Primary file which connects Leasey, LLC to Rent Pro screening API
 */
/*

File handles all api calls for tenants


*/
import { modal } from '../../core/utilities/modal'
import { server } from '../engine/server'
import { basics } from '../../core/engine/helpers/basics.js'

var RentProScreening = Class.create({
    server: null,
  	initialize: function() {
        this.server = server;
    },
	screenTenant: function(data, callback, isLead = false) {
        basics.showLoader();

        const applicant = data.tenantData;
        const customer = data.customerData;
        var params = {
            'PackageName': 'Pro', // make select
            'Customer': {
                "CreditCard": {
                    "cardNumber": customer.credit_card.card_number.replace(/-/g, ""),
                    "cardSecurity": customer.credit_card.card_security,
                    "cardType": customer.credit_card.card_type,
                    "expireMonth": customer.credit_card.expire_month,
                    "expireYear": customer.credit_card.expire_year
                },
                "billingCity": customer.customer_city,
                "billingState": customer.customer_state,
                "billingStreetAddress": customer.customer_streetAddress,
                "billingZip": customer.customer_postalCode,
                "company": customer.customer_companyName,
                "emailAddress": customer.customer_email,
                "firstName": customer.customer_firstname,
                "lastName": customer.customer_lastname,
                "phone": customer.customer_phone.replace(/-/g, ""),
                "referenceId": customer.tenantId
            },
            'Applicant': {
                'city': applicant.tenant_city,
                'dateOfBirth': applicant.tenant_dob,
                'emailAddress': applicant.tenant_email,
                'fax': applicant.tenant_fax,
                'firstName': applicant.tenant_firstname,
                'lastName': applicant.tenant_lastname,
                'middleName': applicant.tenant_middlename,
                'phone': applicant.tenant_phone,
                'postalCode': applicant.tenant_postalCode,
                'ssn': applicant.tenant_ssn,
                'state':applicant.tenant_state,
                'streetAddress': applicant.tenant_streetAddress
            },
            "RequestParameters": {
                "postbackUri": "https://api.leasey.co/v1/api/tenant/screen/results",
                "postback_password": "",
                "postback_username": "",
                "referenceId": data.tenantID,
                "referenceText": "",
                "sendCustomerReceipt": false
            },
            "isLead": isLead
        };

        var url = 'tenant/screen';
        if(isLead) {
            url = 'lead/screen';
        }

        var data = this.server.getData(url, params, true, "POST");
		data
		.done(function(response){
            basics.removeLoader();
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            basics.removeLoader();
			modal.showInfo("Oops! " + e.responseJSON.Message, "danger", "top", "center");
		});
    }
});

export let rentProScreening = new RentProScreening();


// WEBPACK FOOTER //
// app/core/controllers/RentProScreening.js